import * as React from 'react'
import Switch from 'react-switch'

interface Props {
  handleChange: (input: boolean) => void
  checked: boolean
}

const Component: React.FC<Props> = ({ checked, handleChange }) => {
  return (
    <Switch onColor="#5B87F1" uncheckedIcon={false} checkedIcon={false} onChange={handleChange} checked={checked} />
  )
}

export default Component
